var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.module)?_c('router-view',{key:_vm.rerenderKey,attrs:{"module":_vm.module,"instance":_vm.module}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }